<template>
    <div >
        <div class="columns is-multiline">
            <div class="column is-full">
                <b-field label="Producto clasificado."
                message="Usar si este producto es un inmueble o vehiculo.">
                    <b-switch
                    v-model="details.classified">
                    </b-switch>
                </b-field>
            </div>
        </div>
        <div v-if="!details.classified" class="columns is-multiline">
            <div class="column is-full">
                <b-field label="Tiene demoras"
                message="Usar si este producto no esta en stock, o es traido de afuera">
                    <b-switch
                    v-model="details.hasDelay">
                    </b-switch>
                </b-field>
            </div>
            <div class="column is-full">
                <b-field label="Control stock"
                message="Usar si queres llevar el stock de este producto">
                    <b-switch
                    v-model="details.trackStock">
                    </b-switch>
                </b-field>
            </div>
            <div class="column is-full">
                <b-field label="Micro-administrar"
                message="Usar si este producto teine variantes, y queres llevar un stock y/o precio diferencial para cada una.">
                    <b-switch
                    v-model="details.micromanage">
                    </b-switch>
                </b-field>
            </div>
        </div>
        <div class="columns is-multiline">
            <b-loading :is-full-page="true" :active.sync="loading"></b-loading>
            <div class="column is-one-third">
                <b-field label="Titulo">
                    <b-input
                    type="text"
                    v-model="details.title"
                    max="60">
                    </b-input>
                </b-field>
            </div>
            <div class="column is-one-thirds">
                <b-field label="Estado">    
                    <b-select v-model="details.status"  :icon="statusIcon" required expanded>
                        <option value="P">Publico </option>
                        <option value="H">Escondido </option>
                        <option value="O">En oferta </option>
                    </b-select>
                </b-field>
            </div>
            <div class="column is-one-third">
                <b-field label="Codigo">
                    <b-input
                    v-model="details.code"
                    max="30">
                    </b-input>
                </b-field>
            </div>
            <div class="column is-one-third">
                <b-field label="Peso (kg)">
                    <b-numberinput
                    min="0"
                    step="0.01"
                    :controls="false"
                    v-model="details.weightKg">
                    </b-numberinput>
                </b-field>
            </div>
            <div class="column is-two-thirds">
                <b-field label="Garantia">
                    <b-input
                    v-model="details.warranty"
                    max="200"
                    >
                    </b-input>
                </b-field>
            </div>

        </div>
        <div class="columns">
            <div class="column is-two-thirds ">
                <b-field label="Descripcion">
                    <quillEditor
                    class="editor"
                    ref="myTextEditor"
                    :value="details.description"
                    :options="editorOption"
                    @change="onEditorChange"/>
                </b-field>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <b-field label="Seccion/categoria">
                    <b-autocomplete
                    placeholder=""
                    v-model="searchSub"
                    icon="search"
                    :data="subcategories"
                    field="title"
                    :loading = "loadingSub"
                    @input="fetchSubcategories"
                    @select="option => {
                        details.subcategory = option.id
                        searchSub = option.title
                        }"
                    >
                    <template slot-scope="props">
                    <p>{{props.option.categoryTitle}} / {{props.option.title}}</p>
                    </template>
                    <template slot="empty">No section found. Add new section</template>
                    </b-autocomplete>
                </b-field>
            </div>
        </div>

        <div class="columns m-t-20">
            <div class="column is-flex">
                <h2 class="has-text-weight-medium is-size-4">Pricing. </h2>
               
                <b-select  
                    v-model="details.currency" 
                    placeholder="Elige una moneda" 
                    icon="dollar-sign" 
                    required 
                    class="m-l-20"
                    :loading="loadingCurrencies">
                    <option 
                        v-for="x in currencies" 
                        :key="x.id"
                        :value="x.id">
                            {{x.title}} {{x.symbol}}
                    </option>
                </b-select>
               
            </div>
        </div>
        <div class="columns">
            <div class="column is-half">
                <b-field label="Precio de venta">
                    <b-numberinput 
                    v-model="details.price" 
                    min="0"
                    step="0.01"
                    :controls="false">
                    </b-numberinput>
                </b-field>
            </div>
            <div class="column is-half">
                <b-field label="Comparar a">
                    <b-numberinput  
                    step="0.01"
                    :controls="false"
                    v-model="details.compareAt" 
                    min="0">
                    </b-numberinput>
                </b-field>
            </div>
        </div>

        <div class="columns">
            <div class="column is-half">
                <b-field label="Impuesto">
                    <b-select :loading="loadingTaxes" v-model="details.tax" expanded placeholder="Tax" icon="percentage" >
                        <option v-for="x in taxes" :key="x.id" :value="x.id">{{x.title}} - %{{x.percentage}}</option>
                    </b-select>
                </b-field>
            </div>
            <div class="column is-half">
                <b-field label="Costo">
                    <b-numberinput 
                    v-model="details.cost" 
                    min="0" 
                    step="0.01"
                    :controls="false">
                    </b-numberinput>
                </b-field>
            </div>
        </div>
        <div v-if="filterOptions.length" class="columns is-multiline">
            <div class="column is-full">
                <p class="title">Filtros</p>
            </div>
            <div v-for="x in filterOptions" :key="x.id" class="column is-one-third">
                <p class="has-text-weight-bold m-b-5">
                    {{x.title}}
                </p>
                
                <b-checkbox 
                    v-for="opt in x.options" :key="opt.id"
                    size="is-small"
                    v-model="details.filterOptions"
                    :native-value="opt.id">
                    {{opt.title}}
                </b-checkbox>
                
            </div>
        </div>
        <div class="columns is-centered">
            <div class="column is-half has-text-centered">
                <b-button type="is-primary" rounded :loading="loadingPut" @click="saveChanges">
                    <b-icon icon="save" size="is-small"></b-icon>
                    Save changes
                </b-button>
            </div>
        </div>

    </div>
</template>

<script>
import {getHandler, patchHandler, debounce} from "./../../../../services/http.js"
import { quillEditor } from 'vue-quill-editor'
import dedent from 'dedent'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
export default {
    components:{
        quillEditor
    },
    props:{
        productDetailEndpoint:{
            type:String,
            default:""
        },
        taxEndpoint:{
            type:String,
            default:""
        },
        currencyEndpoint:{
            type:String,
            default:""
        },
        subcategoryEndpoint:{
            type:String,
            default:""
        },
        details:{
            type:Object,
            default:new Object({})
        },
        loading:{
            type:Boolean,
            default:false
        },
        searchSub:{
            type:String,
            default:""
        },
        filterOptions:{
            type:Array,
            default: new Array([])
        }
    },
    data(){
        return{
            loadingCurrencies:false,
            loadingTaxes:false,
            loadingPut:false,
            loadingSub:false,
            subcategories:[],
            taxes:[],
            currencies:[],
            editorOption: {
                modules: {
                    toolbar: [
                    ['bold', 'italic', 'underline', 'strike'],
                    ['blockquote', 'code-block'],
                    [{ 'header': 1 }, { 'header': 2 }],
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                    [{ 'script': 'sub' }, { 'script': 'super' }],
                    [{ 'indent': '-1' }, { 'indent': '+1' }],
                    [{ 'direction': 'rtl' }],
                    [{ 'size': ['small', false, 'large', 'huge'] }],
                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                    [{ 'font': [] }],
                    [{ 'color': [] }, { 'background': [] }],
                    [{ 'align': [] }],
                    ['clean'],
                    ['link', 'video']
                    ],
                }
            },
             
        }
    },
    computed:{
        statusIcon(){
            let icon = "times"
            switch(this.details.status){
                case "P":
                    icon = "eye";
                    break;
                case "O":
                    icon = "tag";
                    break;
                case "H":
                    icon = "eye-slash";
                    break;
            }
            return icon
        },

    },
    methods:{
        onEditorChange: debounce(function(value) {
            this.details.description = value.html
        }, 466),
        async fetchDetails(){
           this.$emit("getProd")
        },
        async fetchCurrencies(){
            this.loadingCurrencies = true
            var response = await getHandler(this.currencyEndpoint, {error:false, success:false})
            this.currencies = response
            this.loadingCurrencies = false
        },
        async fetchTaxes(){
            this.loadingTaxes = true
            var response = await getHandler(this.taxEndpoint, {error:false, success:false})
            this.taxes = response
            this.loadingTaxes = false
        },
        
        fetchSubcategories: debounce( async function (){
            this.loadingSub = true
            let url = `${this.subcategoryEndpoint}?name=${this.searchSub}`
            var response = await getHandler(url, {error:false, success:false})
            this.subcategories = response.results
            console.log(this.details)
            this.loadingSub = false
        }, 250),

        async saveChanges(){
            this.loadingPut = true
            var response = await patchHandler(this.productDetailEndpoint, this.details, {error:{resource:'notify'}, success:{resource:'notify'}})
            console.log(response)
            this.fetchDetails()
            this.loadingPut = false
        }   
    },
    created(){
        this.fetchCurrencies()
        this.fetchTaxes()
    }
}
</script>
<style lang="scss" scoped>
.editor {
    height: 400px;
    overflow-y: scroll;
}
</style>